import React, {useState, useEffect, useContext} from 'react';
import { withTranslation, WithTranslation, Trans, useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { Input, 
        InputGroup, 
        InputGroupAddon, 
        FormGroup, 
        FormFeedback, 
        InputGroupText, 
        Dropdown, 
        DropdownToggle, 
        DropdownMenu, 
        DropdownItem,
        Row,
        Col } from 'reactstrap';
import WarningException from '../../services/exception/WarningException';
import Footer from '../../components/Layout/Footer';

import { ModalForgotPassword } from './ModalForgotPassword';

import { languagesList } from "../../utils/Language";
import HttpStorageI18n from "../../services/storage/Language";

// Services
import HttpAuth from '../../services/http/Auth';
import HttpUser from '../../services/http/User';
import StorageAuth from '../../services/storage/Auth';
import StorageUser from '../../services/storage/User';
import StorageCompany from '../../services/storage/Company';

import Notification, { NotificationContainer } from './../Elements/Notification';

// Utils
import RoutePathLibrary from '../../utils/RoutePath';
import RegexLibrary from '../../utils/Regex';

import CssProvider from '../../providers/cssProvider';

import './LoginForm.scss';

interface Props extends WithTranslation {
  location: {
    state: {
      email: string,
      type: string
    }
  }
}

const Login = (props:Props) => {

  const [emailValue, setemailValue] = useState('');
  const [emailIsValid, setemailIsValid] = useState(true);
  const [emailFeedbackMessage, setemailFeedbackMessage] = useState('');
  const [passwordValue, setpasswordValue] = useState('');
  const [passwordIsValid, setpasswordIsValid] = useState(true);
  const [passwordFeedbackMessage, setpasswordFeedbackMessage] = useState('');
  const [rememberMeValue, setrememberMeValue] = useState(true);
  const [showModal, setshowModal] = useState(false);
  const [loading, setloading] = useState(false);
  const [_css] = useContext(CssProvider);

  const [currentLanguage, setCurrentLanguage] = useState(HttpStorageI18n.getCurrentLanguage());
  const [dropdownOpen, setDropdownOpen] = useState(false);
    
  useEffect(()=>{
    handleInit();  
  },[])

  const handleInit = async() => {
    if (props.location.state && props.location.state.email){
      setemailValue(props.location.state.email);
      let err;
      switch (props.location.state.type){
        case "emailNew":
          err = await new WarningException(i18next.t('notificacion-emailNew'));
          Notification.displayException(err);
          break;
        case "emailUsed":
          err = new WarningException(i18next.t('notificacion-emailUsed'));
          Notification.displayException(err);
          break;
      }
      window.history.pushState(null, '');      
    }
  }

  const handleChangeRememberMe = (e: any) => {
    setrememberMeValue(e.target.checked)
  }


  
  const signUp = (e:any) => {
    window.location.href = RoutePathLibrary.signup;
  }

  const handleModalConfirm = async () => {
    setshowModal(!showModal);
    let err = await new WarningException(i18next.t('notificacion-resetPassword'));
    Notification.displayException(err);
  };

  const handleModal = () => {
    setshowModal(!showModal);
  };

  const handleChangeEmail = (e: any) => {
    setemailValue(e.target.value);
    validateEmail(e.target.value);
  };

  const handleChangePassword = (e: any) => {
    setpasswordValue(e.target.value);
    validatePassword(e.target.value);
  };

  const validateEmail = (text:string) => {
    let isValid         = true;
    let feedbackMessage = '';

    if (!text) {
      isValid         = false;
      feedbackMessage = i18next.t('LoginForm-emailEmpty');
    } else if (!RegexLibrary.email.test(text)) {
      isValid         = false;
      feedbackMessage = i18next.t('LoginForm-emailFormat');
    }
    setemailFeedbackMessage(feedbackMessage);
    setemailIsValid(isValid);

    return isValid;
  }

  const validatePassword = (text:string) => {

    let isValid         = true;
    let feedbackMessage = '';

    if (!text) {
      isValid         = false;
      feedbackMessage = i18next.t('LoginForm-emailEmpty');
    } else if (!RegexLibrary.password.test(text)) {
      isValid         = false;
      feedbackMessage = i18next.t('LoginForm-passwordFormat');   
    }

    setpasswordIsValid(isValid);
    setpasswordFeedbackMessage(feedbackMessage);

    return isValid;
  }

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setloading(true);
    
    let response;
    let user;
    try {
      try {
        response = await new HttpAuth().login(emailValue, passwordValue);
      } catch (err) {
        Notification.displayException(err);
        setloading(false);
        return;
      }
      user = await new HttpUser().userLogin(response.idToken);
    } catch (err) {
      Notification.display('error', err.message);
      return;
    } 
    
    StorageUser.saveUser(user.name? user.name : 'User', user.surname? user.surname : '', user.id? user.id : '');
    
    // @ts-ignore
    StorageCompany.saveCompany(user.company ? user.company.name : '');
    setloading(false);

    window.location.href = RoutePathLibrary.home;
  }

  const toggle = () => setDropdownOpen(prevState => !prevState);

  function changeValue(acronym:string) {
    setCurrentLanguage(acronym);
    HttpStorageI18n.saveLanguage(acronym);
    props.i18n.changeLanguage(acronym);
  };

  return (
    <div>
      <NotificationContainer />
        <Row className="mt-4 mr-4 text-right">
          <Col xs={12}>
            <Dropdown isOpen={dropdownOpen} toggle={toggle} >
                <DropdownToggle caret color="primary">
                {
                  <Trans i18nKey={languagesList[languagesList.findIndex( (item:any) => item.acronym === currentLanguage)].title} />
                }
                </DropdownToggle>
                <DropdownMenu className="DropdownMenu-Language">
                {
                    languagesList.map( (el:any) => <DropdownItem onClick={() => changeValue(el.acronym)} key={el.acronym} ><Trans i18nKey={el.title} /></DropdownItem> )
                }
                </DropdownMenu>
            </Dropdown>
          </Col>
        </Row>
        <div>
          <div className="col-12 pb-4 pt-4 mt-5 text-center">
            <h3 className="color-primary">
              <Trans i18nKey={_css.title}></Trans>
            </h3>
          </div>
          <div className="col">
            <div className="col-12 text-center">
              <img className="img-fluid w-auto img-150" src={_css.pathImg} />
            </div>
          </div>
          <div className="col-11 custom-login-form">
            <div className="p-3 custom-box-shadow bg-light">
              <h5 className="section-title text-center margin-top-10 mb-3 color-primary"><Trans i18nKey="Login.Form.Title"></Trans></h5>
              <div id="form-container">
                <div className="col-md-12">
                  <form onSubmit={handleSubmit}>
                    <FormGroup>
                      <InputGroup className="mb-2">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fas fa-at"></i>
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input type="text" placeholder="E-mail" autoFocus={true} invalid={!emailIsValid} value={emailValue} onChange={handleChangeEmail} />
                        <FormFeedback>{ emailFeedbackMessage }</FormFeedback>
                      </InputGroup>
                    </FormGroup>
                    <FormGroup>
                      <InputGroup className="mb-2">
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="fas fa-key"></i>
                            </InputGroupText>
                          </InputGroupAddon>
                        <Input type="password" placeholder="Password" invalid={!passwordIsValid} value={passwordValue} onChange={handleChangePassword} />
                        { passwordValue !== '' && passwordIsValid &&
                          <i className="far fa-check-circle text-success validPassword"></i>
                        }
                        <FormFeedback>{ passwordFeedbackMessage }</FormFeedback>
                      </InputGroup>
                    </FormGroup>
                    {/* <hr/>
                    <div className="row mb-3">
                      <div className="col-12 remember-me-container">
                        <div className="pretty p-default">
                          <input type="checkbox" onChange={this.handleChangeRememberMe} checked={this.state.rememberMeValue} />
                          <div className="state">
                            <label><Trans i18nKey="LoginForm-rememberMe" /></label>
                          </div>
                        </div>
                      </div> 
                    </div> */}
                    <div className="row mb-3">
                      <div className="col-12">
                        <span className="pointer color-primary" onClick={() => setshowModal(!showModal)}><i><Trans i18nKey="Login.Form.ForgotPassword" /></i></span>
                      </div> 
                    </div>
                    <div className="col-md-12 text-center">
                      <div className="row">
                        <div className="col submit-container">
                          <button type="submit" className="btn btn-outline-secondary mb-2 btn-lg" disabled={loading || emailValue === '' || !emailIsValid || passwordValue === '' || !passwordIsValid}>
                            <Trans i18nKey="Login.Form.Submit"></Trans>
                            { loading &&
                              <i className="fas fa-spinner ml-2 fa-spin"></i>
                            }
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="row text-center">
                      <div className="col-12">
                          <small className="pointer" onClick={signUp}><i><Trans i18nKey="Login.Form.AskAccount"></Trans></i>&nbsp;&nbsp;&nbsp;<b><Trans i18nKey="Login.Form.NewAccount"></Trans></b></small>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              {/* <div className="forgot-password-container text-right">
                <small><a href="https://google.es" target="_blank" rel="noopener noreferrer"><Trans i18nKey="Login.Form.ForgotPassword"></Trans></a></small>
              </div> */}
            </div>
          </div>
        </div>
        <div className="footer-login" >
          <Footer />
        </div>
        <ModalForgotPassword modal={showModal} toggleModal={handleModal} clickSubmit={handleModalConfirm} />
    </div>
  );
  
}

export default withTranslation()(Login);
